// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestmentDetailsDto } from './IInvestmentDetailsDto';
import {
    IInvestmentDetailsDtoFromJSON,
    IInvestmentDetailsDtoFromJSONTyped,
    IInvestmentDetailsDtoToJSON,
    IInvestmentDetailsDtoToJSONTyped,
} from './IInvestmentDetailsDto';

/**
 * 
 * @export
 * @interface IInvestmentHoldingsDto
 */
export interface IInvestmentHoldingsDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestmentHoldingsDto
     */
    available_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentHoldingsDto
     */
    available_to_invest?: number;
    /**
     * 
     * @type {IInvestmentDetailsDto}
     * @memberof IInvestmentHoldingsDto
     */
    investor?: IInvestmentDetailsDto;
}

/**
 * Check if a given object implements the IInvestmentHoldingsDto interface.
 */
export function instanceOfIInvestmentHoldingsDto(value: object): value is IInvestmentHoldingsDto {
    return true;
}

export function IInvestmentHoldingsDtoFromJSON(json: any): IInvestmentHoldingsDto {
    return IInvestmentHoldingsDtoFromJSONTyped(json, false);
}

export function IInvestmentHoldingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentHoldingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'available_to_invest': json['available_to_invest'] == null ? undefined : json['available_to_invest'],
        'investor': json['investor'] == null ? undefined : IInvestmentDetailsDtoFromJSON(json['investor']),
    };
}

export function IInvestmentHoldingsDtoToJSON(json: any): IInvestmentHoldingsDto {
    return IInvestmentHoldingsDtoToJSONTyped(json, false);
}

export function IInvestmentHoldingsDtoToJSONTyped(value?: IInvestmentHoldingsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available_balance': value['available_balance'],
        'available_to_invest': value['available_to_invest'],
        'investor': IInvestmentDetailsDtoToJSON(value['investor']),
    };
}

